export const environment = {
  production: false,

  BASE_API_URL: 'https://monjas1.hometech.red/api/public/index.php/',
  HOST: 'hometech.red',
  BASE_API_SOCKET: 'https://soajs-montecerrado.hometech.red/',
  // BASE_API_SOCKET: 'http://89.7.222.195:1503/',

  BASE_APP_URL: '',


  IP_SERVIDOR_SIGNALLING: '83.56.25.97',
  PUERTO_SERVIDOR_SIGNALLING: '9000',

  BASE_FILE_URL: 'https://ideacomonjas-oviedo.hometech.red/',
  BASE_API_URL_RUDY: 'https://eficiencia.hometech.red/api/index.php',
  BASE_API_URL_TIEMPO: 'https://clima.uniquehome.es/clima',

  APP_SEMI_KEY: 'MgcGsDs',

  API_KEY_EDIT: '',

  stunServer: '89.7.222.194:3478',
  turnServer: '89.7.222.194:3478',
  turnServerUsername: 'adminr123',
  turnServerPassword: 'adminr123',
  signallingServerHost: 'https://rtc.hometech.red',
  signallingServerPort: '39186',
};
